module.exports = __webpack_public_path__ + "static/media/dqindex-launch-img.436ab21f.png";